import produce from 'immer';

// TYPES
import { Types, ConsultarSiglas } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: ConsultarSiglas = {
	status: 0,
	data: [],
	totalRegistrosConsulta: 0,
};

export default function consultarSiglasReducer(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarSiglas {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_SIGLAS_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.CONSULTAR_SIGLAS_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				draft.totalRegistrosConsulta =
					action.payload.headers['x-num-registros'];

				break;
			}

			case Types.CONSULTAR_SIGLAS_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.CONSULTAR_SIGLAS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.totalRegistrosConsulta = INITIAL_STATE.totalRegistrosConsulta;
				break;
			}

			default:
		}
	});
}
